// extracted by mini-css-extract-plugin
module.exports =  {"btn":"WAETpWe","icon":"y8M9Kfl","open":"qPVJXxZ"};